import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/boards";

export const comments = {
    // ...example,
    gets(_board, data){
        return axios.get(`${url}/${_board}/comments`, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`, { headers: { code: data?.code } }).then(result => result.data);
    },
    post(_board, data){
        return axios.post(`${url}/${_board}/comments`, data).then(result => result.data);
    },
    put(_board, data){
        return axios.put(`${url}/${_board}/comments/${data._id}`, data).then(result => result.data);
    },
    delete(_board, data){
        return axios.delete(`${url}/${_board}/comments/${data._id}`).then(result => result.data);
    }
}
